import { FC } from 'react'
import MessageList from '..'

interface IProps {}

export const NoAccountMessage: FC<IProps> = (props) => {
    return <MessageList {...props} isNoAccountSMS={true} />
}
